import React from "react";
import "./SharePostButton.css"; // default styling
import { Shareicon } from "../../lib/myIcons";

const SharePostButton = ({ 
  PostId, 
  isLocalHost,
  buttonText = "Share Post", 
  className = "", 
  disabled = false,
  PostObject
}) => {

  const handleSharePost = async () => {
    if (!PostId) return;

    const htmlString = PostObject.description;
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    const plainText = doc.body.textContent || "";

    // console.log("plain text: ",plainText);

    const shareUrl = isLocalHost
      ? `${import.meta.env.VITE_DSERVER_BASEURL}/api/posts/sharepost/${PostId}?v=${Date.now()}`
      : `${import.meta.env.VITE_SH_DSERVER_BASEURL}/api/posts/sharepost/${PostId}?v=${Date.now()}`

    // const shareUrl = isLocalHost
    //   ? `${import.meta.env.VITE_DSERVER_BASEURL}/api/posts/sharepost/${PostId}`
    //   : `${import.meta.env.VITE_SH_DSERVER_BASEURL}/api/posts/sharepost/${PostId}`


    if (navigator.share) {
      try {
        await navigator.share({
          title: `${PostObject.title}`,
          text: `${plainText}'`,
          url: shareUrl,
        });
        console.log("Post shared successfully!");
      } catch (error) {
        console.error("Post sharing failed:", error);
      }
    } else {
      // fallback: copy URL to clipboard
      try {
        await navigator.clipboard.writeText(shareUrl);
        alert("Share link copied to clipboard!");
      } catch {
        alert("Sharing not supported and failed to copy link 😕");
      }
    }
  };

  return (
    <button
      type="button"
      className={`shareButton ${className}`}
      onClick={handleSharePost}
      disabled={disabled || !PostId}
    >
              <Shareicon
                color="white"
                >
              </Shareicon>
      {buttonText}
    </button>
  );
};

export default SharePostButton;
